import { render, staticRenderFns } from "./doc-list.vue?vue&type=template&id=0f2d5ecf&scoped=true&"
import script from "./doc-list.vue?vue&type=script&lang=js&"
export * from "./doc-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d5ecf",
  null
  
)

export default component.exports